import type { ReactNode } from 'react';
import { cn } from '../../lib/utils.ts';
import { fieldVariants } from './fieldStyles.ts';
import Switch from './Switch.tsx';

type LabeledToggleProps = {
    label: string;
    accessory?: ReactNode;
    checked?: boolean | null;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
    'aria-invalid'?: boolean;
};

export function LabeledToggle({
    label,
    accessory,
    checked,
    onChange,
    disabled,
    className,
    'aria-invalid': ariaInvalid,
}: LabeledToggleProps) {
    return (
        <div
            className={cn(fieldVariants(), "flex items-center justify-between", className)}
            aria-invalid={ariaInvalid}
        >
            <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-gray-700">{label}</span>
                {accessory}
            </div>
            <Switch checked={checked === true} onChange={onChange} disabled={disabled} aria-label={label} />
        </div>
    );
}

export default LabeledToggle;
